// Ported from old/js/layout_generator.js (Michael Wehar, MIT License) so the
// admin grid-pattern preview can generate the same crossword layout the old
// PHP page did, without a runtime script include.

function distance(x1, y1, x2, y2) {
  return Math.abs(x1 - x2) + Math.abs(y1 - y2);
}

function weightedAverage(weights, values) {
  let temp = 0;
  for (let k = 0; k < weights.length; k++) {
    temp += weights[k] * values[k];
  }
  return temp;
}

function computeScore1(connections, word) {
  return connections / (word.length / 2);
}

function computeScore2(rows, cols, i, j) {
  return 1 - distance(rows / 2, cols / 2, i, j) / (rows / 2 + cols / 2);
}

function computeScore3(a, b, verticalCount, totalCount) {
  if (verticalCount > totalCount / 2) return a;
  if (verticalCount < totalCount / 2) return b;
  return 0.5;
}

function computeScore4(val, word) {
  return word.length / val;
}

function addWord(best, words, table) {
  const [, word, index, bestI, bestJ, bestO] = best;

  words[index].startx = bestJ + 1;
  words[index].starty = bestI + 1;

  if (bestO === 0) {
    for (let k = 0; k < word.length; k++) {
      table[bestI][bestJ + k] = word.charAt(k);
    }
    words[index].orientation = "across";
  } else {
    for (let k = 0; k < word.length; k++) {
      table[bestI + k][bestJ] = word.charAt(k);
    }
    words[index].orientation = "down";
  }
}

function assignPositions(words) {
  const positions = {};
  for (const index in words) {
    const word = words[index];
    if (word.orientation !== "none") {
      const tempStr = `${word.starty},${word.startx}`;
      if (tempStr in positions) {
        word.position = positions[tempStr];
      } else {
        positions[tempStr] = Object.keys(positions).length + 1;
        word.position = positions[tempStr];
      }
    }
  }
}

function computeDimension(words, factor) {
  let temp = 0;
  for (let i = 0; i < words.length; i++) {
    if (temp < words[i].answer.length) temp = words[i].answer.length;
  }
  return temp * factor;
}

function initTable(rows, cols) {
  const table = [];
  for (let i = 0; i < rows; i++) {
    for (let j = 0; j < cols; j++) {
      if (j === 0) table[i] = ["-"];
      else table[i][j] = "-";
    }
  }
  return table;
}

function isConflict(table, isVertical, character, i, j) {
  if (character !== table[i][j] && table[i][j] !== "-") return true;
  if (table[i][j] === "-" && !isVertical && i + 1 in table && table[i + 1][j] !== "-") return true;
  if (table[i][j] === "-" && !isVertical && i - 1 in table && table[i - 1][j] !== "-") return true;
  if (table[i][j] === "-" && isVertical && j + 1 in table[i] && table[i][j + 1] !== "-") return true;
  if (table[i][j] === "-" && isVertical && j - 1 in table[i] && table[i][j - 1] !== "-") return true;
  return false;
}

/** Random nudge added to each placement score when shuffling — big enough to break
 *  ties and near-ties differently, small enough to keep the heuristic's good picks. */
const SHUFFLE_JITTER = 0.12;

function attemptToInsert(rows, cols, table, weights, verticalCount, totalCount, word, index, rng) {
  const jitter = () => (rng ? rng() * SHUFFLE_JITTER : 0);
  let bestI = 0;
  let bestJ = 0;
  let bestO = 0;
  let bestScore = -1;

  // Horizontal
  for (let i = 0; i < rows; i++) {
    for (let j = 0; j < cols - word.length + 1; j++) {
      let isValid = true;
      let atleastOne = false;
      let connections = 0;
      let prevFlag = false;

      for (let k = 0; k < word.length; k++) {
        if (isConflict(table, false, word.charAt(k), i, j + k)) {
          isValid = false;
          break;
        } else if (table[i][j + k] === "-") {
          prevFlag = false;
          atleastOne = true;
        } else if (prevFlag) {
          isValid = false;
          break;
        } else {
          prevFlag = true;
          connections += 1;
        }
      }

      if (j - 1 in table[i] && table[i][j - 1] !== "-") isValid = false;
      else if (j + word.length in table[i] && table[i][j + word.length] !== "-") isValid = false;

      if (isValid && atleastOne && word.length > 1) {
        const tempScore1 = computeScore1(connections, word);
        const tempScore2 = computeScore2(rows, cols, i, j + word.length / 2);
        const tempScore3 = computeScore3(1, 0, verticalCount, totalCount);
        const tempScore4 = computeScore4(rows, word);
        const tempScore =
          weightedAverage(weights, [tempScore1, tempScore2, tempScore3, tempScore4]) + jitter();
        if (tempScore > bestScore) {
          bestScore = tempScore;
          bestI = i;
          bestJ = j;
          bestO = 0;
        }
      }
    }
  }

  // Vertical
  for (let i = 0; i < rows - word.length + 1; i++) {
    for (let j = 0; j < cols; j++) {
      let isValid = true;
      let atleastOne = false;
      let connections = 0;
      let prevFlag = false;

      for (let k = 0; k < word.length; k++) {
        if (isConflict(table, true, word.charAt(k), i + k, j)) {
          isValid = false;
          break;
        } else if (table[i + k][j] === "-") {
          prevFlag = false;
          atleastOne = true;
        } else if (prevFlag) {
          isValid = false;
          break;
        } else {
          prevFlag = true;
          connections += 1;
        }
      }

      if (i - 1 in table && table[i - 1][j] !== "-") isValid = false;
      else if (i + word.length in table && table[i + word.length][j] !== "-") isValid = false;

      if (isValid && atleastOne && word.length > 1) {
        const tempScore1 = computeScore1(connections, word);
        const tempScore2 = computeScore2(rows, cols, i + word.length / 2, j);
        const tempScore3 = computeScore3(0, 1, verticalCount, totalCount);
        const tempScore4 = computeScore4(rows, word);
        const tempScore =
          weightedAverage(weights, [tempScore1, tempScore2, tempScore3, tempScore4]) + jitter();
        if (tempScore > bestScore) {
          bestScore = tempScore;
          bestI = i;
          bestJ = j;
          bestO = 1;
        }
      }
    }
  }

  if (bestScore > -1) return [bestScore, word, index, bestI, bestJ, bestO];
  return [-1];
}

function generateTable(table, rows, cols, words, weights, rng) {
  let verticalCount = 0;
  let totalCount = 0;

  for (const outerIndex in words) {
    let best = [-1];
    for (const innerIndex in words) {
      if ("answer" in words[innerIndex] && !("startx" in words[innerIndex])) {
        const temp = attemptToInsert(
          rows,
          cols,
          table,
          weights,
          verticalCount,
          totalCount,
          words[innerIndex].answer,
          innerIndex,
          rng
        );
        if (temp[0] > best[0]) best = temp;
      }
    }

    if (best[0] === -1) break;
    addWord(best, words, table);
    if (best[5] === 1) verticalCount += 1;
    totalCount += 1;
  }

  for (const index in words) {
    if (!("startx" in words[index])) words[index].orientation = "none";
  }

  return { table, result: words };
}

function removeIsolatedWords(data) {
  const oldTable = data.table;
  const words = data.result;
  const rows = oldTable.length;
  const cols = oldTable[0].length;
  let newTable = initTable(rows, cols);

  for (const wordIndex in words) {
    const word = words[wordIndex];
    if (word.orientation === "across") {
      const i = word.starty - 1;
      const j = word.startx - 1;
      for (let k = 0; k < word.answer.length; k++) {
        if (newTable[i][j + k] === "-") newTable[i][j + k] = "O";
        else if (newTable[i][j + k] === "O") newTable[i][j + k] = "X";
      }
    } else if (word.orientation === "down") {
      const i = word.starty - 1;
      const j = word.startx - 1;
      for (let k = 0; k < word.answer.length; k++) {
        if (newTable[i + k][j] === "-") newTable[i + k][j] = "O";
        else if (newTable[i + k][j] === "O") newTable[i + k][j] = "X";
      }
    }
  }

  for (const wordIndex in words) {
    const word = words[wordIndex];
    let isIsolated = true;
    if (word.orientation === "across") {
      const i = word.starty - 1;
      const j = word.startx - 1;
      for (let k = 0; k < word.answer.length; k++) {
        if (newTable[i][j + k] === "X") {
          isIsolated = false;
          break;
        }
      }
    } else if (word.orientation === "down") {
      const i = word.starty - 1;
      const j = word.startx - 1;
      for (let k = 0; k < word.answer.length; k++) {
        if (newTable[i + k][j] === "X") {
          isIsolated = false;
          break;
        }
      }
    }
    if (word.orientation !== "none" && isIsolated) {
      delete words[wordIndex].startx;
      delete words[wordIndex].starty;
      delete words[wordIndex].position;
      words[wordIndex].orientation = "none";
    }
  }

  newTable = initTable(rows, cols);
  for (const wordIndex in words) {
    const word = words[wordIndex];
    if (word.orientation === "across") {
      const i = word.starty - 1;
      const j = word.startx - 1;
      for (let k = 0; k < word.answer.length; k++) {
        newTable[i][j + k] = word.answer.charAt(k);
      }
    } else if (word.orientation === "down") {
      const i = word.starty - 1;
      const j = word.startx - 1;
      for (let k = 0; k < word.answer.length; k++) {
        newTable[i + k][j] = word.answer.charAt(k);
      }
    }
  }

  return { table: newTable, result: words };
}

function trimTable(data) {
  const table = data.table;
  const rows = table.length;
  const cols = table[0].length;

  let leftMost = cols;
  let topMost = rows;
  let rightMost = -1;
  let bottomMost = -1;

  for (let i = 0; i < rows; i++) {
    for (let j = 0; j < cols; j++) {
      if (table[i][j] !== "-") {
        if (j < leftMost) leftMost = j;
        if (j > rightMost) rightMost = j;
        if (i < topMost) topMost = i;
        if (i > bottomMost) bottomMost = i;
      }
    }
  }

  const trimmedTable = initTable(bottomMost - topMost + 1, rightMost - leftMost + 1);
  for (let i = topMost; i < bottomMost + 1; i++) {
    for (let j = leftMost; j < rightMost + 1; j++) {
      trimmedTable[i - topMost][j - leftMost] = table[i][j];
    }
  }

  const words = data.result;
  for (const entry in words) {
    if ("startx" in words[entry]) {
      words[entry].startx -= leftMost;
      words[entry].starty -= topMost;
    }
  }

  return {
    table: trimmedTable,
    result: words,
    rows: Math.max(bottomMost - topMost + 1, 0),
    cols: Math.max(rightMost - leftMost + 1, 0),
  };
}

/** box: optional { rows, cols } working area — the finished grid can never exceed it.
 *  rng: optional seeded random source; when given, placements are jittered (shuffle). */
function generateSimpleTable(words, box = null, rng = null) {
  const rows = box ? box.rows : computeDimension(words, 3);
  const cols = box ? box.cols : rows;
  const blankTable = initTable(rows, cols);
  const table = generateTable(blankTable, rows, cols, words, [0.7, 0.15, 0.1, 0.05], rng);
  const newTable = removeIsolatedWords(table);
  const finalTable = trimTable(newTable);
  assignPositions(finalTable.result);
  return finalTable;
}

/** Target shape: slightly wider than tall, like the grid area on the game and admin pages. */
const TARGET_ASPECT = 1.6;

const countPlaced = (layout) => layout.result.filter((w) => w.orientation !== "none").length;

/** How big a grid looks on a landscape screen: the larger of its (aspect-weighted) sides. */
const shapeScore = ({ rows, cols }) => Math.max(rows * TARGET_ASPECT, cols);

/**
 * words: [{ answer, clue, orientation: 'none' }] -> { table, result, rows, cols }
 *
 * Aims for a balanced grid — neither a tall column (vertical scroll) nor a long strip
 * (horizontal scroll). The generator can't place words outside its working table, so
 * capping the table's height (and, separately, its width) steers the layout's shape.
 * Of every attempt that still places as many words as the unrestricted generator, the
 * one with the smallest shapeScore wins. Deterministic, so the admin preview and the
 * game always get the same grid (unless a seeded rng is passed — see generateShuffledLayout).
 */
export function generateLayout(words, rng = null) {
  const fresh = () => words.map((w) => ({ ...w }));
  let best = generateSimpleTable(fresh(), null, rng);
  const target = countPlaced(best);
  const longest = computeDimension(words, 1);
  if (!longest) return best;

  const roomy = longest * 2;
  const boxes = [];
  for (let limit = Math.ceil(longest / 2); limit < roomy; limit += 3) {
    boxes.push({ rows: limit, cols: roomy }); // short and wide working area
    if (limit >= longest) boxes.push({ rows: roomy, cols: limit }); // narrow working area
  }

  for (const box of boxes) {
    const layout = generateSimpleTable(fresh(), box, rng);
    if (countPlaced(layout) < target) continue;
    const diff = shapeScore(layout) - shapeScore(best);
    if (diff < 0 || (diff === 0 && layout.rows < best.rows)) best = layout;
  }
  return best;
}

/** How many grid options "Shuffle Grid" offers (the standard grid counts as the first). */
export const MAX_GRID_OPTIONS = 4;
/** Seeded tries allowed in total, whatever `max` is asked for — keeping this fixed is
 *  what makes a shorter request return exactly the leading options of a longer one. */
const SHUFFLE_ATTEMPTS = (MAX_GRID_OPTIONS - 1) * 3;
/** A shuffled grid may be at most this much bigger (by shapeScore) than the standard one. */
const SHUFFLE_SHAPE_TOLERANCE = 1.25;

/** Small seeded PRNG (mulberry32): the same seed always rebuilds the same grid. */
function makeRng(seed) {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** String -> 32-bit seed (FNV-1a), e.g. from a player's user id. */
export function hashSeed(str) {
  let h = 0x811c9dc5;
  const s = String(str ?? "");
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

/** One shuffled grid: word order shuffled and placement scores jittered from `seed`. */
function generateSeededLayout(words, seed) {
  const rng = makeRng(seed);
  const order = words.slice();
  for (let i = order.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [order[i], order[j]] = [order[j], order[i]];
  }
  return generateLayout(order, rng);
}

const layoutSignature = (layout) => layout.table.map((row) => row.join("")).join("/");

/**
 * The grid options for "Shuffle Grid": the standard grid first, then up to
 * `max - 1` different grids from fixed seeds. A shuffled grid is only kept if it
 * places as many words as the standard one and isn't noticeably bigger.
 *
 * The seeds are fixed, so the same words always give the same options — the admin
 * grid-pattern preview and the game agree without storing anything. Asking for
 * fewer options returns the same leading ones, so the game can stop early.
 */
export function generateLayoutOptions(words, max = MAX_GRID_OPTIONS) {
  const standard = generateLayout(words);
  const options = [standard];
  const seen = new Set([layoutSignature(standard)]);
  const target = countPlaced(standard);
  const maxShape = shapeScore(standard) * SHUFFLE_SHAPE_TOLERANCE;

  for (let attempt = 1; attempt <= SHUFFLE_ATTEMPTS && options.length < max; attempt++) {
    const layout = generateSeededLayout(words, Math.imul(attempt, 0x9e3779b1) >>> 0);
    const sig = layoutSignature(layout);
    if (seen.has(sig)) continue;
    if (countPlaced(layout) < target || shapeScore(layout) > maxShape) continue;
    seen.add(sig);
    options.push(layout);
  }
  return options;
}

/** Row-major numbering, like a standard crossword: first cell of each across/down word gets a number. */
export function getWordStartPositions(words) {
  const positions = {};
  let count = 1;
  const starts = words
    .filter((w) => w.orientation !== "none")
    .slice()
    .sort((a, b) => a.starty - b.starty || a.startx - b.startx);
  for (const word of starts) {
    const key = `${word.starty},${word.startx}`;
    if (!(key in positions)) positions[key] = count++;
  }
  return positions;
}

/** Cell's typing direction: across if the cell to the right is filled, else down. */
export function getCellDirection(row, col, table) {
  if (col + 1 < table[row].length && table[row][col + 1] !== "-") return "across";
  if (row + 1 < table.length && table[row + 1][col] !== "-") return "down";
  return "across";
}
